import { render, staticRenderFns } from "./backoffice-farmacia.vue?vue&type=template&id=aef43430"
import script from "./backoffice-farmacia.vue?vue&type=script&lang=ts"
export * from "./backoffice-farmacia.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-farmacia.vue?vue&type=style&index=0&id=aef43430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports